import React from "react"
import { SplitButton as SplitButtonPrime } from "primereact/splitbutton"

const SplitButton = React.forwardRef(
  /**
   * @param {import("primereact/splitbutton").SplitButtonProps} props
   * @param {React.Ref<typeof SplitButtonPrime>} ref
   * @returns
   */
  (props, ref) => {
    return <SplitButtonPrime {...props} ref={ref} />
  }
)

export default SplitButton
